import { render, staticRenderFns } from "./ExtraFieldsInfo.vue?vue&type=template&id=c9764dac&scoped=true"
import script from "./ExtraFieldsInfo.vue?vue&type=script&lang=ts"
export * from "./ExtraFieldsInfo.vue?vue&type=script&lang=ts"
import style0 from "./ExtraFieldsInfo.vue?vue&type=style&index=0&id=c9764dac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9764dac",
  null
  
)

export default component.exports